import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Home } from '../pages/user/home';
import { AboutUs } from '../pages/user/aboutus';
import { Services } from '../pages/user/services';
import { Products } from '../pages/user/products';
import { OurWorks } from '../pages/user/works';
import { OurTeam } from '../pages/user/ourteam';
import { Contact } from '../pages/user/contact';
import { Feedback } from '../pages/user/feedback';
import { ServiceDetails } from '../pages/user/servicedetails';
import { WhatsNew } from '../pages/user/whatsnew';
import { SingleArticle } from '../pages/user/SingleArticle';
import { StudentDetails } from '../pages/user/StudentDetails';
import { Default } from '../pages/user/default';
import { Careers } from '../pages/user/careers';
import { JobDetail } from '../pages/user/jobdetail';
import { Test } from '../pages/user/test';

export const UserRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/our-services" element={<Services />} />
      <Route path="/our-products" element={<Products />} />
      <Route path="/our-works" element={<OurWorks />} />
      <Route path="/our-team" element={<OurTeam />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/careers/:id" element={<JobDetail />} />
      <Route path="/get-in-touch" element={<Contact />} />
      <Route path="/give-your-feedback" element={<Feedback />} />
      <Route path="/service-details/:name/:id" element={<ServiceDetails />} />
      <Route path="/whats-new" element={<WhatsNew />} />
      <Route path="/article-details/:slug/:id" element={<SingleArticle />} />
      <Route path="/student-details" element={<StudentDetails />} />
      <Route path="/default" element={<Default />} />
      <Route path="/test" element={<Test />} />
    </Routes>
  );
};
